export const environment = {
  production: true,
  API_URL: (window as any)['env']?.API_URL || 'https://bffoperator-dev.trueconnect.one',
  API_BASE_URL: (window as any)['env']?.API_BASE_URL || 'https://bffchat-dev.trueconnect.one',
  HUB_URL: (window as any)['env']?.HUB_URL || 'https://chatsystemrcs-dev.trueconnect.one/operatorHub',
  API_URL_NO_AUTH2: (window as any)['env']?.API_URL_NO_AUTH2 || 'https://bffoperator-dev.trueconnect.one',
  name: 'dev',
  API_URL_ADDRESS: (window as any)['env']?.API_URL_ADDRESS || 'https://bffoperator-dev.trueconnect.one',
  URL_CDN_UPLOAD: (window as any)['env']?.URL_CDN_UPLOAD || 'https://cdn-test.eztek.net/gateway/Media/Upload',
};
